import ITestBeginState from './ITestBeginState';
import TestStartContext from './TestStartContext';
import TestStartDisplayType from './TestStartDisplayType';

class StartButtonState implements ITestBeginState {
  private readonly context: TestStartContext;
  constructor(context: TestStartContext) {
    this.context = context;
  }

  performFunction(): void {
    //Do Nothing
  }

  getView(): TestStartDisplayType {
    return TestStartDisplayType.START;
  }
}

export default StartButtonState;
